export const lightGreenColor = '#e6f0d0';
export const lightOrangeColor = '#ffeedb';
export const lightBlueColor = '#e5f7fe';
export const lightRedColor = '#fce3e3';
export const lightGreyColor = '#f1f1f1';
export const greenBorderColor = '#81B214';
export const orangeBorderColor = '#F58634';
export const blueBorderColor = '#00AEEF';
export const redBorderColor = '#F53434';
export const greyBorderColor = '#CCCCCC';

export const getBorderColor = (color) => {
  switch (color) {
    case 'green':
      return greenBorderColor;
    case 'blue':
      return blueBorderColor;
    case 'orange':
      return orangeBorderColor;
    case 'red':
      return redBorderColor;
    default:
      return greyBorderColor;
  }
};

export const getBackgroundColor = (color) => {
  switch (color) {
    case 'green':
      return lightGreenColor;
    case 'blue':
      return lightBlueColor;
    case 'orange':
      return lightOrangeColor;
    case 'red':
      return lightRedColor;
    default:
      return lightGreyColor;
  }
}

export const getLighterColor = (hexColor, lightenAmount = 0.9) => {
  if (!/^#([0-9a-f]{3}){1,2}$/i.test(hexColor)) {
    throw new Error("Invalid hex color format");
  }

  // Convert hex to RGB
  let r, g, b;
  if (hexColor.length === 4) {
    r = parseInt(hexColor[1] + hexColor[1], 16);
    g = parseInt(hexColor[2] + hexColor[2], 16);
    b = parseInt(hexColor[3] + hexColor[3], 16);
  } else {
    r = parseInt(hexColor.slice(1, 3), 16);
    g = parseInt(hexColor.slice(3, 5), 16);
    b = parseInt(hexColor.slice(5, 7), 16);
  }

  // Convert to HSL
  const rNorm = r / 255, gNorm = g / 255, bNorm = b / 255;
  const max = Math.max(rNorm, gNorm, bNorm);
  const min = Math.min(rNorm, gNorm, bNorm);
  let h, s, l = (max + min) / 2;

  if (max === min) {
    h = s = 0;
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case rNorm: h = (gNorm - bNorm) / d + (gNorm < bNorm ? 6 : 0); break;
      case gNorm: h = (bNorm - rNorm) / d + 2; break;
      case bNorm: h = (rNorm - gNorm) / d + 4; break;
      default: break;
    }
    h /= 6;
  }

  // Lighten the color
  const newL = lightenAmount;

  // Convert HSL back to RGB
  const hue2rgb = (p, q, t) => {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  };

  const q = newL < 0.5 ? newL * (1 + s) : newL + s - newL * s;
  const p = 2 * newL - q;

  const rL = Math.round(hue2rgb(p, q, h + 1 / 3) * 255);
  const gL = Math.round(hue2rgb(p, q, h) * 255);
  const bL = Math.round(hue2rgb(p, q, h - 1 / 3) * 255);

  const toHex = (v) => v.toString(16).padStart(2, '0');
  const lighterHex = `#${toHex(rL)}${toHex(gL)}${toHex(bL)}`;

  return lighterHex;
}